import React from 'react';

import { StyledIconBgButton } from '@/shared/components/ui/button/header-icon-button/header-icon-button.styled';
import { THeaderIconButton } from '@/shared/components/ui/button/header-icon-button/header-icon-button.types';

export const HeaderIconButton: React.FC<THeaderIconButton> = (props) => {
  return <StyledIconBgButton size="large" variant="secondary" {...props} />;
};
